import moment from 'moment';
import React, { useEffect, useState } from 'react';
import jsCalendar from 'js-calendar';
import { leadingZero } from  '@/helpers/Text';



export interface WeekBuilder {
    firstDay: Date;
    lastDay: Date;
    days: Date[];
    currentWeek: number;
    forward: () => void;
    back: () => void;
    setByWeekNo: (weekNo: number) => void;
    setByDay: (date: Date) => void;
}
export interface jsDay {
    date: Date,
    desc: number,
    format: string,
    index:  number,
    type: string,
    week: number,
    year: number
}

interface ICurrdate {
    year:number,
    month:number, 
    week:number
}

const useWeekBuilder = ():WeekBuilder => {
  
    const defaultDate = new Date();

    const [currentDate, setCurrentDate] = useState<ICurrdate>({
        year:defaultDate.getFullYear(), 
        month:defaultDate.getMonth(), 
        week:moment().isoWeek()
    })

    const [firstDay, setFirstDay] = useState<Date|null>(null)
    const [lastDay, setLastDay] = useState<Date|null>(null)
    const [days, setDays] = useState<Date[]>([])

    // Get Dates for selected week
    useEffect(() => {
          
       

        if (!currentDate.week) return

        const week = [moment(`${currentDate.year}W${leadingZero(currentDate.week)}`).toDate()]

        if (!currentDate.week) return

        for (let i = 1; i < 7  ; i++) {
            const newDate = moment(`${currentDate.year}W${leadingZero(currentDate.week)}`).add(i, 'days').toDate() 
            week.push(newDate)
        }


        if (week.length){
            setFirstDay(week[0])
            setLastDay(week[6]) 
            setDays(week)
        }
        
    }, [currentDate])

    function move(back:boolean){

        const val = back ? -1 : 1;

        let date = {year:currentDate.year, month:currentDate.month, week:currentDate.week + val }

        // If back & week is zero move back year
        if (back && !date.week){
            date = {year:date.year - 1, month:12, week:52};
        }

        if (!back && date.week === 53){
            date = {year:date.year + 1, month:0, week:1};
        }

        const jsCal = new jsCalendar.Generator({onlyDays: true});

        const hasWeeks = jsCal(date.year, date.month).cells.filter(x => x.week === date.week).length;

        // Move week back if empty
        if (!hasWeeks){
            date = {...date, month:date.month + val};
        }

        setCurrentDate(date)
    }

    const back = function back(){
        move(true)
    }

    const forward = function forward(){
        move(false)
    }

    const setByWeekNo = function(weekNo:number){

        setCurrentDate((date) => {
            return {
                ...date, 
                week: weekNo,
            }
        })
    }

    const setByDay = function(date:Date){

        // Build up first day of week from week from date

        const weekNo = moment(date).isoWeek();

        const mondayWeek = moment().day("Monday").year(date.getFullYear()).week(weekNo).toDate();
        // Set to Monday regardless of which day in week selected
        setCurrentDate({
            year:getYear(date, mondayWeek),
            month: mondayWeek.getMonth(),
            week: weekNo
        })

    }

    return {firstDay, lastDay, days, currentWeek:currentDate.week, forward, back, setByWeekNo, setByDay}

};

function getYear(date, weekStarting) {

    const wasLastYear = date.getMonth() === 0 && weekStarting.getMonth() === 11
   
    return wasLastYear ? date.getFullYear() - 1 : date.getFullYear();
}

export default useWeekBuilder;